
import {
    Injectable, ElementRef, Component, Input, AfterViewInit, OnInit,
    Type, ViewContainerRef, ViewChild, ViewEncapsulation, Renderer2, Inject
} from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';
import 'rxjs/add/operator/map';

@Component({
    selector: 'abs-modals-and-alerts-component',
    template: `<ng-content></ng-content>


`,
    styles: [`:host ::ng-deep .modalwrapper{display:none;height:100%;width:100%;left:0;overflow-y:hidden;-webkit-overflow-scrolling:touch;position:fixed;right:0;padding:0 20px;top:0;z-index:-1}:host ::ng-deep .modalwrapper .modal{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;background-clip:padding-box;background-color:#fff;border:none;border-radius:8px;-webkit-box-shadow:0 3px 8px 3px rgba(0,0,0,.4);box-shadow:0 3px 8px 3px rgba(0,0,0,.4);margin:20px auto;outline:0;height:auto;min-height:150px;overflow:hidden;width:100%;z-index:1060}:host ::ng-deep .modalwrapper .modal.fade{-webkit-transition:opacity .3s linear 0s;transition:opacity .3s linear 0s;border:none;opacity:0}:host ::ng-deep .modalwrapper .modal.fade.in{position:relative;overflow:auto;z-index:1060;opacity:1;-webkit-transition:opacity .3s linear 0s;transition:opacity .3s linear 0s}:host ::ng-deep .modalwrapper .modal.fade.in.modal-landscape{overflow-y:auto}:host ::ng-deep .modalwrapper .modal .modal-header{-ms-flex-align:center;-webkit-box-align:center;align-items:center;border-radius:8px 8px 0 0;min-height:60px;overflow:hidden;padding:25px 46px 20px 30px;position:relative}:host ::ng-deep .modalwrapper .modal .modal-header.text-center{padding-left:46px}:host ::ng-deep .modalwrapper .modal .modal-header h2:focus{outline:0}:host ::ng-deep .modalwrapper .modal .modal-header>h2{line-height:1;margin:0;padding:0}:host ::ng-deep .modalwrapper .modal .modal-header [class*=icon-]:before{top:-1px}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button{border-radius:50%;height:27px;position:absolute;width:27px;right:12px;top:12px;border:1px solid #959595}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close{float:none;height:27px;margin:0;position:absolute;right:-1px;top:-1px;width:27px}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close[data-focus-method=KEY]:focus{outline:#191919 dotted 1px;outline-offset:4px}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close:before{color:#5a5a5a;display:block;font-size:18px;height:auto;position:absolute;right:0;top:.1rem;bottom:0;left:0;-webkit-text-size-adjust:100%;-webkit-transform:translateY(15%);transform:translateY(15%);width:auto;margin:0}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close-modal-button{width:17px;background:#fff;border:0;padding:0;margin-left:4px}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close-modal-button:focus{outline:#191919 dotted 1px;outline-offset:4px}:host ::ng-deep .modalwrapper .modal .modal-header .corner-button .close-modal-button .modal-close-icon{color:#5a5a5a;font-size:18px;margin-right:4px}:host ::ng-deep .modalwrapper .modal .modal-header-portrait{-webkit-overflow-scrolling:auto}:host ::ng-deep .modalwrapper .modal .modal-header-landscape{-webkit-overflow-scrolling:auto}:host ::ng-deep .modalwrapper .modal .modal-footer>.cta-button-group{line-height:40px;border-top:1px solid #d2d2d2}:host ::ng-deep .modalwrapper .modal .modal-docked-body.modal-body{height:80%;overflow-y:auto;padding-bottom:60px}:host ::ng-deep .modalwrapper .modal .modal-docked-body.modal-body>:last-child{margin-bottom:30px}:host ::ng-deep .modalwrapper .modal .modal.text-center .modal-header{display:block}:host ::ng-deep .modalwrapper .modal .modal-body{-webkit-overflow-scrolling:touch;position:relative;padding:20px 30px;width:auto}:host ::ng-deep .modalwrapper .modal .modal-body:focus{outline:#191919 dotted 1px}:host ::ng-deep .modalwrapper .modal .modal-header+.modal-body{padding:0 30px 20px}:host ::ng-deep .modalwrapper .modal .modal-form{margin-bottom:0}:host ::ng-deep .modalwrapper .modal .modal-footer{background-color:#fff;width:100%;padding:0 30px;border-radius:0;position:absolute;bottom:0}:host ::ng-deep .modalwrapper .modal .modal-footer .cta-button-group .btn{margin-bottom:10px}:host ::ng-deep .modalwrapper .modal .modal-footer,:host ::ng-deep .modalwrapper .modal .modal-landscape .modal-footer{position:relative}:host ::ng-deep .modalwrapper .modal.modal-centered .modal-header{padding-bottom:20px;-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center}:host ::ng-deep .modalwrapper .modal.modal-centered .modal-header>h2{font-size:2.4rem;color:#191919;line-height:.78;-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center}:host ::ng-deep .modalwrapper .modal.modal-centered .modal-header>h2>label{font-family:font-regular,Omnes-ATT-W02;font-size:inherit;font-weight:400;margin-bottom:0;line-height:.78}:host ::ng-deep .modalwrapper .modal.modal-centered .modal-body{text-align:center}:host ::ng-deep .modalwrapper .modal.modal-centered .modal-body .modal-footer-content{margin-top:15px}:host ::ng-deep .modalwrapper.modal-docked{position:fixed;height:100%;padding:0;-webkit-overflow-scrolling:auto;-ms-flex-align:center;-webkit-box-align:center;align-items:center}:host ::ng-deep .modalwrapper.modal-docked .modal,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in{max-height:100%;height:80%;overflow:hidden;top:0}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header{-ms-flex-align:center;-webkit-box-align:center;align-items:center;border-radius:8px 8px 0 0;min-height:60px;overflow:hidden;padding:25px 46px 20px 30px;position:relative}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header.text-center,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header.text-center{padding-left:46px}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header>h2,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header>h2{line-height:1;margin:0;padding:0}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header.modal-header-portrait,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header.modal-header-portrait{-webkit-overflow-scrolling:auto}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header.modal-header-landscape,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header.modal-header-landscape{-webkit-overflow-scrolling:auto}:host ::ng-deep .modalwrapper.modal-docked .modal .modal-header [class*=icon-]:before,:host ::ng-deep .modalwrapper.modal-docked .modal.fade.in .modal-header [class*=icon-]:before{top:-1px}:host ::ng-deep .modalwrapper.modal-docked.fade.in{overflow:hidden}:host ::ng-deep .modalwrapper.modal-fullscreen,:host ::ng-deep .modalwrapper.modal-fullscreen>.modal{height:auto;width:100%;top:0;bottom:0;right:0;left:0;margin:0;padding:0;max-width:none;border-radius:0}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal{display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;height:100%;overflow:hidden}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal .modal-header{top:0;-ms-flex:0 120px;-webkit-box-flex:0;flex:0 120px}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal .corner-button{z-index:2000;top:27px;right:27px}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal .modal-footer{bottom:0;-ms-flex:0 auto;-webkit-box-flex:0;flex:0 auto}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal .modal-footer .cta-button-group{padding-bottom:20px}:host ::ng-deep .modalwrapper.modal-fullscreen>.modal .modal-footer .cta-button-group button{margin:0 auto}:host ::ng-deep .modalwrapper .modal-small{max-width:420px}:host ::ng-deep .modalwrapper .modal-medium{max-width:620px}:host ::ng-deep .modalwrapper .modal-large{max-width:720px}:host ::ng-deep .modalwrapper .modal-xlarge{max-width:860px}:host ::ng-deep .modalwrapper .modal-jumbo{max-width:1000px}:host ::ng-deep .modalwrapper .modal-long-adjust{-ms-flex-item-align:start;align-self:flex-start}:host ::ng-deep .modalwrapper.active{display:-ms-flexbox;display:-webkit-box;display:flex;z-index:1050;overflow-y:auto}:host ::ng-deep .modalwrapper.dark-theme .modal-fullscreen .modal,:host ::ng-deep .modalwrapper.dark-theme.modal-fullscreen .modal{background:#191919;color:#d2d2d2}:host ::ng-deep .modalwrapper.dark-theme .modal-fullscreen .corner-button,:host ::ng-deep .modalwrapper.dark-theme.modal-fullscreen .corner-button{border-color:#d2d2d2;background-color:#191919}:host ::ng-deep .modalwrapper.dark-theme .modal-fullscreen .modal-footer,:host ::ng-deep .modalwrapper.dark-theme.modal-fullscreen .modal-footer{background-color:#333;border-top:1px #191919}:host ::ng-deep .modalwrapper.light-theme .modal-fullscreen .modal,:host ::ng-deep .modalwrapper.light-theme.modal-fullscreen .modal{background:#fff;color:#5a5a5a}:host ::ng-deep .modalwrapper.light-theme .modal-fullscreen .corner-button,:host ::ng-deep .modalwrapper.light-theme.modal-fullscreen .corner-button{border-color:#5a5a5a;background-color:#fff}:host ::ng-deep .modalwrapper.light-theme .modal-fullscreen .corner-button .close:before,:host ::ng-deep .modalwrapper.light-theme.modal-fullscreen .corner-button .close:before{color:#5a5a5a}:host ::ng-deep .modalwrapper.light-theme .modal-fullscreen .modal-footer,:host ::ng-deep .modalwrapper.light-theme.modal-fullscreen .modal-footer{background-color:#333;border-top:1px #191919}:host ::ng-deep .modalwrapper .modal-alert .modal-header [class*=icon-],:host ::ng-deep .modalwrapper .modal-success .modal-header [class*=icon-]{font-size:30px;vertical-align:text-bottom}:host ::ng-deep .modalwrapper .modal-alert .modal-header>h2,:host ::ng-deep .modalwrapper .modal-success .modal-header>h2{-ms-flex-align:start;-webkit-box-align:start;align-items:flex-start}:host ::ng-deep .modalwrapper .modal-success .modal-header [class*=icon-],:host ::ng-deep .modalwrapper .modal-success .modal-header h2{color:#007a3e}:host ::ng-deep .modalwrapper .modal-alert .modal-header [class*=icon-],:host ::ng-deep .modalwrapper .modal-alert .modal-header h2{color:#cf2a2a}:host ::ng-deep .modalwrapper .modal-alert .modal-header>h2,:host ::ng-deep .modalwrapper .modal-confirmation .modal-header>h2,:host ::ng-deep .modalwrapper .modal-success .modal-header>h2{display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-align:baseline;-webkit-box-align:baseline;align-items:baseline}:host ::ng-deep .no-focus-outline{outline:0}@media (max-width:767px){:host ::ng-deep .modalwrapper{overflow-x:hidden;padding:0 15px}:host ::ng-deep .modalwrapper.active{display:block}:host ::ng-deep .modalwrapper.modal-docked .modal.fade{margin:0;max-width:100%!important;max-height:100%;height:100%;border-radius:0}:host ::ng-deep .modalwrapper.modal-docked .modal-header{border-radius:0}:host ::ng-deep .modalwrapper.modal-docked.modal-landscape{overflow-y:hidden;position:fixed}:host ::ng-deep .modalwrapper.modal-docked.modal-landscape .modal-header{border-radius:0}:host ::ng-deep .modalwrapper.modal-docked.modal-landscape .modal.fade.in{overflow-y:scroll;max-width:100%}:host ::ng-deep .modalwrapper.modal-docked .modal-docked-body.modal-body{height:auto;overflow-y:hidden}:host ::ng-deep .modalwrapper .modal.fade,:host ::ng-deep .modalwrapper .modal.fade.in{top:0;right:0;left:0;margin:15px auto;padding:0;border:none}:host ::ng-deep .modalwrapper .modal.fade .modal-header,:host ::ng-deep .modalwrapper .modal.fade.in .modal-header{padding:20px 46px 20px 15px}:host ::ng-deep .modalwrapper .modal.fade .modal-header>h2,:host ::ng-deep .modalwrapper .modal.fade.in .modal-header>h2{font-size:2.4rem}:host ::ng-deep .modalwrapper .modal.fade .modal-header+.modal-body,:host ::ng-deep .modalwrapper .modal.fade.in .modal-header+.modal-body{width:100%;padding:0 15px 15px}:host ::ng-deep .modalwrapper .modal-footer{padding:0 15px}:host ::ng-deep .modalwrapper .modal-footer .cta-button-group .btn+.btn{margin-bottom:0}}@media (orientation:landscape) and (max-width:767px){:host ::ng-deep .modalwrapper .modal-docked-body.modal-body{min-height:184px}}`],
})

@Injectable()
export class ModalsAndAlertsComponent implements AfterViewInit, OnInit {
    public elemBody :any = document.body;
    public elemModal;
    public elemOverlaySpinner;
    public elemLink;
    public loadingText: string;
    //  Input variables declared to fetch data from the demo-component
    @Input('sizeClass') public sizeClass: string;
    @Input('windowClass') public windowClass: string;
    public htmlContent;
    public i: number;
    public items = ['item1', 'item2', 'item3'];
    @ViewChild('placeholder', { read: ViewContainerRef }) elementRef;
    @Input() type: Type<Component>;
    public isDockedModal;
    public selector;
    public title;
    public describedby;
    public titleId;
    public contentId;
    public isNotif;
    public id;
    public tabArray;
    public stayOpen;
    public isMobile: any = /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    constructor(
        @Inject(ElementRef) private element: ElementRef,
        @Inject(Renderer2) private renderer: Renderer2
    ) {}
    //  Initializes the component
    ngOnInit() {
        this.id = (typeof this.id === 'undefined') ? this.getRandomId() : this.id;
        this.sizeClass = this.element.nativeElement.getAttribute('sizeClass');
        this.windowClass = this.element.nativeElement.getAttribute('windowClass');
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            this.elemModal = this.element.nativeElement.querySelector('.modalwrapper');
            this.elemOverlaySpinner = this.elemModal.querySelector('.modal.fade');
            this.renderer.listen(this.elemOverlaySpinner, 'keydown', (event) => {
                if (event.which === 27) {
                    const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
                    if (elemLoaderOverlay !== null) {
                        this.modalCloseKeydown(event);
                    }
                }
            });
            this.title = this.element.nativeElement.getAttribute('modal-title');
            this.renderer.listen(document.body, 'keydown', (event) => {
                if (this.element.nativeElement.querySelector('.modalwrapper').classList[1] == 'active') {
                    if (event.shiftKey === false && event.which === 9 && (this.tabArray[this.tabArray.length - 1] === event.target)) {
                        event.preventDefault();
                        this.tabArray[0].focus();
                    } else if ((event.shiftKey && event.which === 9) && (this.tabArray[0] === event.target)) {
                        event.preventDefault();
                        this.tabArray[this.tabArray.length - 1].focus();
                    } else {
                        return
                    }

                }
            });
            const instance = this;
            this.renderer.listen(document, 'click', (event) => {
                const selectors = document.body.querySelectorAll('abs-modals-and-alerts-component');
                for (let i = 0; i < selectors.length; i++) {
                    if (selectors[i].contains(event.target)) {
                        this.selector = selectors[i];
                    }
                }
                if (instance.selector !== undefined && instance.selector !== null) {
                    instance.stayOpen = instance.selector.getAttribute('stay-open');
                }

                if (instance.selector !== undefined && event.target === this.element.nativeElement.children[0]) {
                    this.modalLoader(event);
                } else if (instance.selector !== undefined && instance.selector !== undefined &&
                    instance.stayOpen !== 'true' && instance.selector.querySelector('.modalwrapper') == event.target) {
                    this.modalClose(event.target);
                } else if (instance.selector !== undefined && instance.selector !== undefined &&
                    instance.selector.querySelector('.modalwrapper') !== null && instance.selector.querySelector('.modalwrapper').children[0].contains(event.target)) {
                    return;
                }
            });
        } else {
            for (let i = 0; i < document.body.querySelectorAll('app-modal-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('app-modal-and-alerts-content-component')[i] !== null &&
                    document.body.querySelectorAll('app-modal-and-alerts-content-component')[i] !== undefined) {
                    this.renderer.listen(document.body.querySelectorAll('app-modal-and-alerts-content-component')[i].querySelector('.modal.fade'), 'keydown', (event) => {
                        if (event.which === 27) {
                            const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
                            if (elemLoaderOverlay !== null) {
                                this.modalCloseKeydown(event);
                            }
                        }
                    });
                    this.renderer.listen(document.body, 'keydown', (event) => {
                        if (document.body.querySelectorAll('app-modal-and-alerts-content-component')[i].querySelector('.modalwrapper').classList[1] == 'active') {
                            if (event.shiftKey === false && event.which === 9 &&
                                (this.tabArray[this.tabArray.length - 1] == event.target)) {
                                event.preventDefault();
                                this.tabArray[0].focus();
                            } else if ((event.shiftKey && event.which === 9) && (this.tabArray[0] == event.target)) {
                                event.preventDefault();
                                this.tabArray[this.tabArray.length - 1].focus();
                            } else {
                                return
                            }
                        }
                    });
                }
            }
            var instance = this;
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            this.renderer.listen(document, 'click', (event) => {
                if (instance.element.nativeElement !== undefined && instance.element.nativeElement !== null) {
                    instance.stayOpen = instance.element.nativeElement.getAttribute('stay-open');
                }

                if (modalDiv !== undefined && event.target === this.element.nativeElement.children[0]) {
                    this.modalLoader(event);
                } else if (modalDiv !== undefined && instance.stayOpen !== 'true' &&
                    modalDiv.querySelector('.modalwrapper') == event.target) {
                    this.modalClose(event.target);
                } else if (modalDiv !== undefined && modalDiv !== undefined &&
                    modalDiv.querySelector('.modalwrapper').children[0].contains(event.target)) {
                    return;

                }
            });
            if (modalDiv !== null && modalDiv !== undefined) {
                this.renderer.listen(modalDiv.querySelector('.modal.fade'), 'keydown', (event) => {
                    if (event.which === 27) {
                        const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
                        if (elemLoaderOverlay !== null) {
                            this.modalCloseKeydown(event);
                        }
                    }
                });
            }
            this.renderer.listen(document.body, 'keydown', (event) => {
                if (modalDiv.querySelector('.modalwrapper').classList[1] == 'active') {
                    if (event.shiftKey === false && event.which === 9 && (this.tabArray[this.tabArray.length - 1] == event.target)) {
                        event.preventDefault();
                        this.tabArray[0].focus();
                    } else if ((event.shiftKey && event.which === 9) && (this.tabArray[0] == event.target)) {
                        event.preventDefault();
                        this.tabArray[this.tabArray.length - 1].focus();
                    } else {
                        return
                    }

                }
            });
        }
        this.elemLink = this.element.nativeElement.querySelector('a');
        this.loadingText = 'Log In';
    }
    //  Responds after Angular2 initializes the component's views and child views
    ngAfterViewInit() {
        const cssClass = this.sizeClass.split(' ');

        if (!this.element.nativeElement.hasAttribute('modalName')) {

            const dialogDiv = this.element.nativeElement.querySelector('.modal.fade');
            for (let i = 0; i < cssClass.length; i++) {
                if (cssClass[i] !== '') {
                    this.addClass(dialogDiv, cssClass[i]);
                }
            }
        } else {
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            const dialogDiv = modalDiv.querySelector('.modal.fade');
            for (let i = 0; i < cssClass.length; i++) {
                if (cssClass[i] !== '') {
                    this.addClass(dialogDiv, cssClass[i]);
                }
            }
        }
    }
    //  this function loads the modal by creating a new div element in the DOM and adding necessary classes to show the modal
    public modalLoader(event) {
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            this.i = 1;
            this.elemBody = document.body;
            var instance = this;
            this.elemOverlaySpinner = this.elemModal.querySelector('.modal.fade');
            const titleref = this.element.nativeElement.querySelector('[modal-title]');
            if (titleref) {
                this.describedby = titleref.getAttribute('describedby');
                this.titleId = titleref.getAttribute('id');
                if (this.describedby) {
                    this.isNotif = true;
                    this.setTitle(this.titleId, this.describedby);
                } else {
                    this.isNotif = false;
                    this.setTitle(this.titleId, null);
                }
            }

            const selectors = document.body.querySelectorAll('abs-modals-and-alerts-component');
            for (let i = 0; i < selectors.length; i++) {
                if (selectors[i].contains(event.target)) {
                    this.selector = selectors[i];
                    let contentModal = this.selector.querySelector('abs-modals-and-alerts-content-component');
                    this.tabArray = contentModal.children[0].children[0].querySelectorAll('[tabindex],a,button,textarea,input');
                }
            }
            const focusModal = this.selector.querySelector('.modal.fade');
            this.elemModal = this.selector.querySelector('.modalwrapper');
            this.addClass(this.elemModal, 'active');
            const loaderDiv = '<div id="loaderOverlay" class="modal-backdrop fade hidden-by-modal" aria-hidden="true"></div>';
            var overlayPosition = this.selector.getAttribute('overlayPosition');
            if (overlayPosition !== null && overlayPosition !== undefined) {
                let contentModal = this.selector;
                contentModal.insertAdjacentHTML('beforeEnd', loaderDiv);
            } else {
                this.elemBody.insertAdjacentHTML('beforeEnd', loaderDiv);
            }

            this.elemModal.setAttribute('aria-hidden', false);
            if ((this.windowClass !== undefined) && (this.windowClass !== null)) {
                const windowCssClass = this.windowClass.split(' ');
                for (let i = 0; i < windowCssClass.length; i++) {
                    this.addClass(this.elemModal, windowCssClass[i]);
                }
                this.setModalHeight();
                this.renderer.listen('window', 'orientationchange', () => {
                    this.setModalHeight();
                });
                this.renderer.listen('window', 'resize', () => {
                    this.setModalHeight();
                });
            }

            let contentModal = this.selector.querySelector('abs-modals-and-alerts-content-component');
            //  adds class on HTML and body element
            this.addClass(this.elemBody.parentElement, 'styled-by-modal');
            this.addClass(this.elemBody, 'styled-by-modal');
            setTimeout(() => {
                this.addClass(instance.elemBody.querySelector('#loaderOverlay'), 'in');
                this.fixUpCSS(instance.elemBody.querySelector('#loaderOverlay'), { 'position': 'fixed' });
                setTimeout(() => {
                    instance.addClass(instance.selector.querySelector('.modal.fade'), 'in');
                    focusModal.focus();
                    if (this.isNotif) {
                        var buttonArr = instance.selector.querySelectorAll('button');
                        buttonArr[1].focus();
                    } else {
                        const headingFocus = this.selector.querySelector('[modal-title]');
                        if (headingFocus !== null) {
                            headingFocus.setAttribute('tabindex', 0);
                            headingFocus.focus();
                            headingFocus.setAttribute('tabindex', -1);
                        }
                    }
                    focusModal.parentElement.scrollTop = 0;
                }, 350);
            }, 200);
        } else {
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            var instance = this;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            this.elemOverlaySpinner = modalDiv.querySelector('.modal.fade')
            const titleref = modalDiv.querySelector('[modal-title]');
            if (titleref) {
                this.describedby = titleref.getAttribute('describedby');
                this.titleId = titleref.getAttribute('id');
                if (this.describedby) {
                    this.isNotif = true;
                    this.setTitle(this.titleId, this.describedby);
                } else {
                    this.isNotif = false;
                    this.setTitle(this.titleId, null);
                }
            }
            let contentModal = modalDiv;
            this.tabArray = contentModal.children[0].children[0].querySelectorAll('[tabindex],a,button,textarea,input');
            this.elemModal = modalDiv.querySelector('.modalwrapper');
            this.addClass(this.elemModal, 'active');
            const loaderDiv = '<div id="loaderOverlay" class="modal-backdrop fade hidden-by-modal" aria-hidden="true"></div>';
            this.elemBody.insertAdjacentHTML('beforeEnd', loaderDiv);
            this.elemModal.setAttribute('aria-hidden', false);
            if ((this.windowClass !== undefined) && (this.windowClass !== null)) {
                const windowCssClass = this.windowClass.split(' ');
                for (let i = 0; i < windowCssClass.length; i++) {
                    this.addClass(this.elemModal, windowCssClass[i]);
                }
                this.setModalHeight();
                this.renderer.listen('window', 'orientationchange', () => {
                    this.setModalHeight();
                });
                this.renderer.listen('window', 'resize', () => {
                    this.setModalHeight();
                });
            }
            this.addClass(this.elemBody.parentElement, 'styled-by-modal');
            this.addClass(this.elemBody, 'styled-by-modal');
            setTimeout(() => {
                this.addClass(instance.elemBody.querySelector('#loaderOverlay'), 'in');
                this.fixUpCSS(instance.elemBody.querySelector('#loaderOverlay'), { 'position': 'fixed' });
                const focusModal = modalDiv.querySelector('.modal.fade');
                setTimeout(() => {
                    instance.addClass(modalDiv.querySelector('.modal.fade'), 'in');
                    focusModal.focus();
                    if (this.isNotif) {
                        var buttonArr = instance.selector.querySelectorAll('button');
                        buttonArr[1].focus();
                    } else {
                        if (this.isMobile) {
                            const headingFocus = this.selector.querySelector('[modal-title]');
                            if (headingFocus !== null) {
                                headingFocus.setAttribute('tabindex', 0);
                                headingFocus.focus();
                                headingFocus.setAttribute('tabindex', -1);
                            }
                        }
                    }
                    focusModal.parentElement.scrollTop = 0;
                }, 350);
            }, 200);
        }
    }
    //  closes the modal by removing the classes
    public modalClose(event) {
        this.elemBody = document.body;
        var instance = this;
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            const modalref = document.body.querySelectorAll('abs-modals-and-alerts-content-component');
            for (let i = 0; i < modalref.length; i++) {
                if (modalref[i].contains(event)) {
                    instance.elemModal = modalref[i].querySelector('.modalwrapper');
                    instance.elemOverlaySpinner = instance.elemModal.querySelector('.modal.fade');
                    const elemLoaderOverlay = instance.elemBody.querySelector('#loaderOverlay');
                    instance.removeClass(instance.elemOverlaySpinner, 'in');
                    setTimeout(() => {
                        instance.removeClass(instance.elemBody, 'styled-by-modal');
                        instance.removeClass(instance.elemBody.parentElement, 'styled-by-modal');
                        instance.removeClass(instance.elemModal, 'active');
                        if (elemLoaderOverlay != null && elemLoaderOverlay !== undefined) {
                            instance.removeClass(elemLoaderOverlay, 'in');
                        }
                        setTimeout(() => {
                            const elemLoaderOverlay = instance.elemBody.querySelector('#loaderOverlay');
                            if (elemLoaderOverlay != null && elemLoaderOverlay !== undefined) {
                                var overlayPosition = modalref[i].parentElement.getAttribute('overlayPosition');
                                if (overlayPosition !== null && overlayPosition !== undefined) {
                                    let contentModal = modalref[i].parentElement;
                                    contentModal.removeChild(elemLoaderOverlay);
                                } else {
                                    instance.elemBody.removeChild(elemLoaderOverlay);
                                }
                            }
                        }, 450);
                    }, 350);
                }
            }
        } else {
            const modalref = document.body.querySelectorAll('abs-modals-and-alerts-content-component');
            for (let i = 0; i < modalref.length; i++) {
                if (modalref[i].contains(event)) {
                    instance.elemModal = modalref[i].querySelector('.modalwrapper');
                    instance.elemOverlaySpinner = instance.elemModal.querySelector('.modal.fade');
                    const elemLoaderOverlay = instance.elemBody.querySelector('#loaderOverlay');
                    instance.removeClass(instance.elemOverlaySpinner, 'in');
                    setTimeout(() => {
                        instance.removeClass(instance.elemBody, 'styled-by-modal');
                        instance.removeClass(instance.elemBody.parentElement, 'styled-by-modal');
                        instance.removeClass(instance.elemModal, 'active');
                        if (elemLoaderOverlay != null && elemLoaderOverlay !== undefined) {
                            instance.removeClass(elemLoaderOverlay, 'in');
                        }
                        setTimeout(() => {
                            const elemLoaderOverlay = instance.elemBody.querySelector('#loaderOverlay');
                            if (elemLoaderOverlay != null && elemLoaderOverlay !== undefined) {
                                var overlayPosition = modalref[i].parentElement.getAttribute('overlayPosition');
                                if (overlayPosition !== null && overlayPosition !== undefined) {
                                    let contentModal = modalref[i].parentElement;
                                    contentModal.removeChild(elemLoaderOverlay);
                                } else {
                                    instance.elemBody.removeChild(elemLoaderOverlay);
                                }
                            }
                        }, 450);
                    }, 350);
                }
            }
        }

    }
    //  closes the modal on key press
    public modalCloseKeydown(event) {
        this.elemBody = document.body;
        var instance = this;
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            this.elemModal = this.element.nativeElement.querySelector('.modalwrapper');
            this.elemOverlaySpinner = this.elemModal.querySelector('.modal.fade');
            this.element.nativeElement.focus();
            const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
            this.removeClass(this.elemOverlaySpinner, 'in');
            this.removeClass(elemLoaderOverlay, 'in');
            setTimeout(() => {
                this.removeClass(this.elemBody, 'styled-by-modal');
                this.removeClass(this.elemBody.parentElement, 'styled-by-modal');
                this.removeClass(this.elemModal, 'active');
            }, 500);
            setTimeout(() => {
                const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
                if (elemLoaderOverlay !== null) {
                    var overlayPosition = instance.elemModal.parentElement.parentElement.getAttribute('overlayPosition');
                    if (overlayPosition !== null && overlayPosition !== undefined) {
                        let contentModal = instance.elemModal.parentElement.parentElement.parentElement;
                        contentModal.removeChild(elemLoaderOverlay);
                    } else {
                        instance.elemBody.removeChild(elemLoaderOverlay);
                    }
                }
            }, 600);
        } else {
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            var instance = this;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            this.elemModal = modalDiv.querySelector('.modalwrapper');
            this.elemOverlaySpinner = this.elemModal.querySelector('.modal.fade');
            this.element.nativeElement.focus();
            const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
            this.removeClass(this.elemOverlaySpinner, 'in');
            this.removeClass(elemLoaderOverlay, 'in');
            setTimeout(() => {
                this.removeClass(this.elemBody, 'styled-by-modal');
                this.removeClass(this.elemBody.parentElement, 'styled-by-modal');
                this.removeClass(this.elemModal, 'active');
            }, 500);
            setTimeout(() => {
                const elemLoaderOverlay = this.elemBody.querySelector('#loaderOverlay');
                if (elemLoaderOverlay !== null) {
                    instance.elemBody.removeChild(elemLoaderOverlay);
                }
            }, 600);
        }

    }
    //  handles aria-accessibility for title of the modal
    public setTitle(title, describedby) {
        this.title = title;
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            const titleref = this.element.nativeElement.querySelector('.modalwrapper');
            titleref.setAttribute('aria-labelledby', title);
            titleref.children[0].setAttribute('aria-labelledby', title);
            if (describedby) {
                titleref.setAttribute('aria-describedby', describedby);
                titleref.children[0].setAttribute('aria-describedby', describedby);
            }
        } else {
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            const titleref = modalDiv.querySelector('.modalwrapper');
            titleref.setAttribute('aria-labelledby', title);
            titleref.children[0].setAttribute('aria-labelledby', title);
            if (describedby) {
                titleref.setAttribute('aria-describedby', describedby);
                titleref.children[0].setAttribute('aria-describedby', describedby);
            }
        }

    }
    //  this function sets the height of the modal upon loading
    public setModalHeight() {
        this.isDockedModal = this.windowClass.indexOf('modal-docked') > -1;
        let modalHeaderHeight, modalFooterHeight, modalBodyHeight, windowHeight, windowWidth, modalHeight, modalElement;
        modalHeaderHeight = 0;
        modalFooterHeight = 0;
        windowHeight = window.innerHeight;
        windowWidth = window.innerWidth;
        if (!this.element.nativeElement.hasAttribute('modalName')) {
            if (this.isDockedModal) {
                const modalElements = this.element.nativeElement.querySelector('.modal.fade').children;
                const modalParent = this.element.nativeElement.querySelector('.modal.fade').parentElement;
                for (let i = 0; i < modalElements.length; i++) {
                    if (modalElements[i].className === 'modal-header') {
                        modalHeaderHeight = modalElements[i].offsetHeight;
                    } else if (modalElements[i].className === 'modal-footer') {
                        modalFooterHeight = modalElements[i].offsetHeight;
                    }
                }
                modalElement = this.element.nativeElement.querySelector('.modal');
                modalHeight = modalElement.offsetHeight;
                modalBodyHeight = modalHeight - (modalHeaderHeight + modalFooterHeight) + 'px';
                const modalbody = this.element.nativeElement.querySelector('.modal-body');
                this.fixUpCSS(modalbody, { height: modalBodyHeight });
                if (this.isPortrait()) { // Potrait Mode
                    this.removeClass(modalParent, 'modal-landscape');
                    this.fixUpCSS(modalbody, { height: modalBodyHeight });
                } else if (this.isLandscape()) { // Landscape Mode Mobile
                    this.addClass(modalParent, 'modal-landscape');
                    modalbody.removeAttribute('style');
                    if (windowWidth >= 768) {
                        this.fixUpCSS(modalbody, { height: modalBodyHeight });
                    }
                }

            }
        } else {
            var modalName = this.element.nativeElement.getAttribute('modalName');
            var modalDiv;
            for (let i = 0; i < document.body.querySelectorAll('abs-modals-and-alerts-content-component').length; i++) {
                if (document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i].getAttribute('modalName') == modalName) {
                    modalDiv = document.body.querySelectorAll('abs-modals-and-alerts-content-component')[i]
                }
            }
            if (this.isDockedModal) {
                const modalElements = modalDiv.querySelector('.modal.fade').children;
                const modalParent = modalDiv.querySelector('.modal.fade').parentElement;
                for (let i = 0; i < modalElements.length; i++) {
                    if (modalElements[i].className === 'modal-header') {
                        modalHeaderHeight = (<HTMLScriptElement[]><any>modalElements)[i].offsetHeight;
                    } else if (modalElements[i].className === 'modal-footer') {
                        modalFooterHeight = (<HTMLScriptElement[]><any>modalElements)[i].offsetHeight;
                    }
                }
                modalElement = modalDiv.querySelector('.modal');
                modalHeight = (<HTMLScriptElement[]><any>modalElement.parentElement.children)[0].offsetHeight;
                modalBodyHeight = modalHeight - (modalHeaderHeight + modalFooterHeight) + 'px';
                const modalbody = modalDiv.querySelector('.modal-body');
                this.fixUpCSS(modalbody, { height: modalBodyHeight });
                if (this.isPortrait()) { // Potrait Mode
                    this.removeClass(modalParent, 'modal-landscape');
                    this.fixUpCSS(modalbody, { height: modalBodyHeight });
                } else if (this.isLandscape()) { // Landscape Mode Mobile
                    this.addClass(modalParent, 'modal-landscape');
                    this.fixUpCSS(modalbody, { height: 'auto' });
                }
            }
        }
    }
    public isPortrait() {
        return window.innerHeight > window.innerWidth;
    }
    public isMobileView() {
        if (window.innerWidth < 480) {
            return true;
        } else {
            return false;
        }
    }
    public isLandscape() {
        return (window.innerWidth < 1025 && window.innerHeight < window.innerWidth);
    }
    public getRandomId() {
        return Math.floor((Math.random() * 6) + 1);
    }
    //  generic functions to add, remove a class or set the css on element
    public addClass(element, className) {
        this.renderer.addClass(element, className);
    }
    public removeClass(element, className) {
        this.renderer.removeClass(element, className);
    }
    public fixUpCSS(element, cssObject) {
        for (let key = 0; key < Object.keys(cssObject).length; key++) {
            // element.style[Object.keys(cssObject)[key]] = cssObject[Object.keys(cssObject)[key]];
        };
    };
}
